import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { captureException } from '@sentry/react';
import { GET_SHIPPER_SURVEY_QUESTIONS } from '../../queries';
import { SURVEY_SECTIONS } from './constants';
import { groupSurveyQuestions } from './utils';

const SURVEY_TYPES = SURVEY_SECTIONS.map(({ type }) => type);

/**
 * The shipper's enabled survey questions, grouped into the Surveys page sections.
 * @param {string} shipperId the shipper's client id
 * @returns {{ sections: ReturnType<typeof groupSurveyQuestions>, loading: boolean, error?: Error }}
 */
export const useShipperSurveys = (shipperId) => {
    const { data, loading, error } = useQuery(GET_SHIPPER_SURVEY_QUESTIONS, {
        variables: { client_id: shipperId, survey_types: SURVEY_TYPES },
        skip: !shipperId,
        onError: (e) => captureException(e),
    });

    const sections = useMemo(() => groupSurveyQuestions(data?.survey_questions), [data]);

    return { sections, loading, error };
};
